<section class="user-register" *appHasPermission="userPermissions.MODULE">
  <div class="user-register__header">
    <app-breadcrumb [home]="home" [items]="breadcrumbs"></app-breadcrumb>
    <div class="user-register__header__map d-none">
      <i class="pi pi-map d-none"></i>
    </div>
  </div>
  <div class="user-register__header">
    <div class="user-register__header__title">
      <div class="user-register__header__title__icon" (click)="cancelRegister()">
        <i class="pi pi-arrow-left"></i>
      </div>
      <h1>{{ userId ? (tk.User.EditUser | t) : (tk.User.AddUser | t) }}</h1>
    </div>
    <div class="user-register__header__actions">
      <div class="user-register__header__actions__button">
        <app-button
          [id]="'cancel-register'"
          [label]="tk.User.Cancel | t"
          [type]="'button'"
          [theme]="'white'"
          (sendButtonClick)="cancelRegister()"></app-button>
      </div>
      <div
        class="user-register__header__actions__button"
        *appHasPermission="userPermissions.CREATE">
        <app-button
          [id]="'register-user'"
          [label]="tk.User.Finish | t"
          [type]="'button'"
          [disabled]="userRegisterForm.invalid"
          (sendButtonClick)="registerUser()"></app-button>
      </div>
    </div>
  </div>
  <div class="user-register__content">
    <form *ngIf="userRegisterForm" [formGroup]="userRegisterForm" appAutoFormGroup>
      <!-- Card: Dados Cadastrais -->
      <app-form-card
        icon="pi pi-user"
        title="{{ tk.User.Information | t }}"
        description="Informações básicas do usuário">
        <div class="form-group">
          <div class="row mb-3">
            <div class="col-12 col-md-3">
              <app-select
                [label]="tk.User.Status | t"
                [options]="userStatusOptions"
                [selectedOption]="selectedStatus"
                (sendSelectedOption)="handleOptionChange($event, 'selectedStatus')"
                [placeholder]="tk.User.Select | t"></app-select>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-12 col-md-4">
              <app-input
                [type]="'text'"
                [placeholder]="tk.User.FirstName | t"
                [controlName]="userRegisterProps.firstName"
                [label]="tk.User.Name | t"
                [required]="true"></app-input>
            </div>
            <div class="col-12 col-md-4">
              <app-input
                [type]="'text'"
                [placeholder]="tk.User.SecondName | t"
                [controlName]="userRegisterProps.surName"
                [label]="tk.User.Lastname | t"
                [required]="true"></app-input>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-12 col-md-8">
              <app-input
                [type]="'email'"
                [placeholder]="tk.General.Insert | t"
                [controlName]="userRegisterProps.email"
                [label]="tk.User.Email | t"
                [required]="true"></app-input>
            </div>
            <div class="col-12 col-md-4">
              <app-input
                type="useMask"
                [unmask]="true"
                mask="+99 (99) 99999-9999"
                placeholder="+55 (11) 99999-9999"
                [autoClear]="false"
                [controlName]="userRegisterProps.phoneNumber"
                [label]="tk.User.Phone | t"
                [required]="false"></app-input>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-12 col-md-3">
              <app-select
                [label]="tk.User.Type | t"
                [options]="userTypeOptions"
                [selectedOption]="selectedUserType"
                (sendSelectedOption)="handleOptionChange($event, 'selectedUserType')"
                [placeholder]="tk.User.Select | t"></app-select>
            </div>

            <ng-container *ngIf="shouldShowTenantOptions">
              <div class="col-12 col-md-3">
                <app-select
                  [label]="tk.User.Tenant | t"
                  [options]="tenantOptions"
                  [selectedOption]="selectedTenant"
                  (sendSelectedOption)="handleOptionChange($event, 'selectedTenant')"
                  [placeholder]="tk.User.Select | t"></app-select>
              </div>
            </ng-container>

            <!--
              Parceiro comercial do usuário. Sem ele o usuário do tipo PARTNER entra na
              plataforma sem deal e sem empresa nenhuma — as duas coisas saem deste vínculo.
            -->
            <ng-container *ngIf="shouldShowPartnerOptions">
              <div class="col-12 col-md-3">
                <app-select
                  label="Parceiro"
                  [options]="partnerOptions"
                  [formControlName]="userRegisterProps.partnerId"
                  [placeholder]="tk.User.Select | t"></app-select>
              </div>
            </ng-container>

            <div class="col-12">
              <app-checkbox
                *ngIf="!userId && selectedUserType?.label === 'COMPANY'"
                [checkbox]="sendOnboardingEmailCheckbox"
                [hasSelectionHighlight]="true"
                (sendCheckedChange)="handleCheckedChange($event, 'sendOnboardingEmail')">
              </app-checkbox>
              <app-checkbox
                [checkbox]="isPublicGlobalBackofficeUserCheckbox"
                [hasSelectionHighlight]="true"
                (sendCheckedChange)="handleCheckedChange($event, 'isPublicGlobalBackofficeUser')">
              </app-checkbox>
            </div>
          </div>
          <!--
            Escopo de empresas. Na edição segue sempre visível (comportamento anterior);
            na criação aparece quando o tipo selecionado é COMPANY — único caso em que o
            escopo faz sentido. Na criação não existe `userId` ainda, então o painel roda
            em modo seletor (`autoSave = false`) e o escopo é persistido após o POST.
          -->
          <ng-container *appHasRole="'TENANT'">
            <div class="row mb-3" *ngIf="userId || shouldShowCompaniesOptions">
              <div class="col-12">
                <app-user-access-panel
                  #accessPanel
                  [userId]="userId || undefined"
                  [autoSave]="!!userId"
                  [partnerMode]="isPartnerUserType"></app-user-access-panel>
              </div>
            </div>
          </ng-container>
        </div>
      </app-form-card>

      <!-- Card: Permissões -->
      <ng-container
        *ngIf="
          permissionsGroups?.length ||
          (permissionsGroupsAdminTenant?.admin && permissionsGroupsAdminTenant?.tenant)
        ">
        <app-form-card
          icon="pi pi-lock"
          title="{{ tk.User.PermissionsGroup | t }}"
          description="Definição de acesso e permissões">
          <div class="row px-0">
            <ng-container
              *ngIf="
                (selectedUserType?.label || '').includes('+');
                else defaultPermissionGroupSelection
              ">
              <ng-container
                *ngFor="
                  let permissionsKey of permissionsGroupsAdminTenantAsArray;
                  let iPermissionsKey = index
                ">
                <div class="col-12 col-sm-6 mb-3">
                  <h4 class="user-register__content__title mb-3">
                    {{ tk.User.PermissionsGroup | t }} -
                    {{ (selectedUserType?.label || '').split('+')[iPermissionsKey] || '' }}
                  </h4>
                  <div class="form-group">
                    <div class="d-flex flex-column">
                      <ng-container
                        *ngIf="permissionsKey === 'tenant'; else adminCheckboxesTemplate">
                        <ng-container *ngFor="let permissionTenant of permissionsTenantCheckboxes">
                          <app-checkbox
                            [checkbox]="permissionTenant"
                            [hasSelectionHighlight]="true"
                            (sendCheckedChange)="handleCheckedChange($event, 'tenant')">
                          </app-checkbox>
                        </ng-container>
                      </ng-container>
                      <ng-template #adminCheckboxesTemplate>
                        <ng-container *ngFor="let permissionAdmin of permissionsAdminCheckboxes">
                          <app-checkbox
                            [checkbox]="permissionAdmin"
                            [hasSelectionHighlight]="true"
                            (sendCheckedChange)="handleCheckedChange($event, 'admin')">
                          </app-checkbox>
                        </ng-container>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>

            <ng-template #defaultPermissionGroupSelection>
              <div class="col-12">
                <h4 class="user-register__content__title mb-3">
                  {{ tk.User.PermissionsGroup | t }} -
                  {{ selectedUserType?.label || '' }}
                </h4>
                <div class="form-group">
                  <div formArrayName="permissionsGroupsIds" class="d-flex flex-column">
                    <ng-container *ngFor="let permission of permissionsCheckboxes">
                      <app-checkbox
                        [checkbox]="permission"
                        [hasSelectionHighlight]="true"
                        (sendCheckedChange)="handleCheckedChange($event, 'default')">
                      </app-checkbox>
                    </ng-container>
                  </div>
                </div>
              </div>
            </ng-template>
          </div>
        </app-form-card>
      </ng-container>

      <!-- Card: Localização -->
      <app-form-card
        icon="pi pi-globe"
        title="{{ tk.User.Localization | t }}"
        description="Configurações regionais do usuário">
        <div class="form-group">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-3">
              <app-select
                [label]="tk.User.Language | t"
                [options]="userLanguagesOptions"
                [selectedOption]="selectedLanguage"
                (sendSelectedOption)="handleOptionChange($event, 'selectedLanguage')"
                [placeholder]="tk.User.Select | t"></app-select>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
              <app-select
                [label]="tk.User.DateFormat | t"
                [options]="userDateFormatsOptions"
                [selectedOption]="selectedDateFormat"
                (sendSelectedOption)="handleOptionChange($event, 'selectedDateFormat')"
                [placeholder]="tk.User.Select | t"></app-select>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
              <app-select
                [label]="tk.User.TimeFormat | t"
                [options]="userTimeFormatsOptions"
                [selectedOption]="selectedTimeFormat"
                (sendSelectedOption)="handleOptionChange($event, 'selectedTimeFormat')"
                [placeholder]="tk.User.Select | t"></app-select>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
              <app-select
                [label]="tk.User.Timezone | t"
                [options]="userTimeZoneOptions"
                [selectedOption]="selectedTimeZone"
                (sendSelectedOption)="handleOptionChange($event, 'selectedTimeZone')"
                [placeholder]="tk.User.Select | t"></app-select>
            </div>
          </div>
        </div>
      </app-form-card>

      <!-- Card: Preferencias de Notificacao -->
      <!-- A seção de mudança de etapa no kanban só vale para usuário do TENANT: o aviso não
           chega a usuário de empresa-cliente. Aqui quem decide é a empresa escolhida para o
           usuário sendo cadastrado, e não o papel de quem está cadastrando. -->
      <!-- Usuário parceiro não tem preferências de notificação (card 3517): as seções são de
           módulos que ele não acessa, então o card nem aparece. A seção Mercado (Relatório Semanal
           de Mercado, card 3617) aparece só se os grupos marcados para o usuário editado dão
           MARKETMONITOR_VIEW. -->
      @if (!hidesNotificationPreferences) {
        <app-notification-preferences-form
          #notificationPreferencesForm
          [showRiskStageChangeSection]="!selectedCompany"
          [showMarketSection]="showMarketPreferenceSection">
        </app-notification-preferences-form>
      }

      <!-- Card: Assinatura de e-mail (card 3456) -->
      <app-user-email-signature-form #emailSignatureForm [editing]="!!userId">
      </app-user-email-signature-form>
    </form>
  </div>
</section>
